export default __webpack_public_path__ + "static/media/be1a253a94b446aa40e204b1540303b4.png";